<template>
	<div class="infobox-generic-wrapper" :class="state">
		<div class="title" v-html="label"/>
		<div
		v-for="(content, index) in contentInfo"
		:key="content"
		class="information-container"
		:class="{'apply-border': index < (contentInfo.length - 1), positive: content.status === 'success'}">
			<component :is="contentIcon(content.status)"/>
			<div class="info" v-html="content.info"/>
			<component
			v-if="content.status !== 'invalid'"
			:is="contentButton(content.status)"
			buttonSize="small"
			:label="content.buttonLabel"
			@clicked="emit('buttonClicked', content.id)"/>
		</div>
	</div>
</template>

<script setup>
/* Vue */
import {	defineAsyncComponent } from 'vue'

/** props received
@label { String, Number }
@content { Array }
*/
const props = defineProps({
	label: [String, Number],
	contentInfo: Array
})

const emit = defineEmits(['buttonClicked'])

const iconsMapper = {
	success: 'check-circle',
	unavailable: 'block',
	inactive: 'info'
}

const buttonMapper = {
	success: 'Tertiary',
	inactive: 'Primary'
}

const contentIcon = status => {
	const iconSelected = iconsMapper[status]
    return defineAsyncComponent(() => import('@/assets/icons/' + iconSelected + '.svg?inline'))
}

const contentButton = status => {
	if (status === 'unavailable') return

	const button = buttonMapper[status]
    return defineAsyncComponent(() => import('@/components/generic/buttons/' + button))
}
</script>

<style lang="scss">
.infobox-generic-wrapper {
	width: 100%;
	max-width: 508px;
	min-height: 40px;
	padding: 16px;

	display: flex;
	flex-direction: column;
	gap: 24px;

	flex-direction: column;
	justify-content: center;
	align-items: flex-start;

	border-radius: 8px;
	border: 1px solid var(--secondary-light-1);
	background-color: var(--secondary-light-3);

	.title {
		min-height: 16px;

		@include H7-Medium;
		line-height: 16px;
		color: var(--secondary-dark-2);
	}

	.information-container {
		width: 100%;

		display: flex;
		justify-content: flex-start;
		align-items: center;

		.info  {
			width: 100%;
			max-width: 444px;

			@include H7-Regular;
			line-height: 16px;
			color: var(--secondary-dark-2);
		}

		svg {
			width: 24px;
			height: 24px;

			margin-right: 4px;
			flex-shrink: 0;

			.change-color-fill {
				fill: var(--secondary-dark-2);
			}
		}

		&.positive {
			border-color: var(--positive);

			.info {
				width: 100%;

				@include H7-Medium;
				color: var(--positive);

			}
			svg {
				.change-color-fill {
					fill: var(--positive);
				}
			}
		}

		&.apply-border {
			padding-bottom: 16px;
			border-bottom: 1px solid var(--secondary-light-1);
		}
	}
}
</style>
